import RefundManagerContainer from "../../container/admin/refund-manager";

const RefundManager = () => {
    return <RefundManagerContainer />;
};

export default RefundManager;